import React, { Fragment, useState } from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { useInView } from 'react-intersection-observer'
import Collapse from 'reactstrap/lib/Collapse'
import CardBody from 'reactstrap/lib/CardBody'
import RenderInnerHTML from '../RenderInnerHTML'

const setClassName = (isMobile, isPDP, isCategory, isSearch) => {
  if (isMobile || isPDP) return 'rct-page'
  if (isCategory) return 'rct-page_cat'
  if (isSearch) return 'rct-page-search'
  return 'rct-page_d'
}

const LegalInfo = (props) => {
  const [legalOpen, setLegalOpen] = useState(false)
  const { showCampaignCyberLegal, showCampaignTextLegal } = useSelector((state) => state.campaignConfigReducer)
  const { ref: refLegal, inView: legalInView } = useInView({
    threshold: 0,
  })

  const renderLegalBody = (html) => (
    <CardBody>
      <div id="legal-text" style={{ fontSize: '10px', textAlign: 'justify' }}>
        <RenderInnerHTML html={html} />
      </div>
    </CardBody>
  )

  const toggleLegal = () => {
    setLegalOpen(!legalOpen)
  }

  const renderLegalInfo = (text) => {
    const { isMobile, isPDP, isCategory, isSearch } = props
    const pdpStyle = isPDP ? 'rct-page_pdp' : ''

    const data = text.split('|')
    let title
    let body
    if (data.length === 1) {
      title = 'Condiciones legales'
      body = text
    } else {
      title = data[0].toString()
      body = data[1].toString()
    }

    return (
      <div className="rct-app-content" data-testid="legal-info-section" ref={refLegal}>
        <div>
          <div className="content-wrapper">
            <div className="shop-wrapper" style={{ background: '#f5f5f5', margin: 'auto', marginTop: '-1px' }}>
              <div className={setClassName(isMobile, isPDP, isCategory, isSearch)}>
                <div className={`pb-30 ${pdpStyle}`}>
                  <div className="row">
                    {!isMobile && <div className="col-1" />}
                    <div
                      role="presentation"
                      id="renderLegalInfo"
                      className="col-12 bg-white cp-no-select"
                      style={{
                        padding: '10px',
                        boxShadow: '0 1px 3px 0px rgba(0, 0, 0, .2)',
                        borderRadius: '8px',
                      }}
                      onKeyPress={toggleLegal}
                      onClick={toggleLegal}
                    >
                      <span className="span-legal">{`${legalOpen ? 'Ocultar ' : 'Ver '}${title}`}</span>
                      <span className="pull-right">
                        <img
                          alt="white-arrow"
                          height="18"
                          src="/catalogo/images/arrow_blue.svg"
                          style={legalOpen ? { transform: 'rotate(90deg)' } : { transform: 'none' }}
                        />
                      </span>
                      {legalInView && <Collapse isOpen={legalOpen}>{renderLegalBody(body)}</Collapse>}
                    </div>
                    {!isMobile && <div className="col-1" />}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }

  return <Fragment>{showCampaignCyberLegal && renderLegalInfo(showCampaignTextLegal)}</Fragment>
}

LegalInfo.defaultProps = {
  isPDP: false,
  isCategory: false,
  isSearch: false,
}

LegalInfo.propTypes = {
  isMobile: PropTypes.bool.isRequired,
  isPDP: PropTypes.bool,
  isCategory: PropTypes.bool,
  isSearch: PropTypes.bool,
}

export default LegalInfo
